import { Form, FormRule } from "antd";
import { NamePath } from "antd/es/form/interface";
import * as React from "react";
import { SelectCatalogId } from "src/business/catalog/SelectCatalog";
import { $ZodType } from "zod/v4/core";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";

type PropsMetaSelectCatalogId = {
  node: $ZodType;
  path: NamePath;
  field?: FieldDef;
};

export const MetaSelectCatalogId: React.FC<PropsMetaSelectCatalogId> = (
  props,
) => {
  const { node, path, field } = props;
  const rules: FormRule[] = [];
  if (!field?.optional) {
    rules.push({ required: true, message: "Необходимо выбрать каталог" });
  }
  return (
    <Form.Item
      name={itemName(path)}
      label={makeLabel(node, path, field)}
      rules={rules}
    >
      <SelectCatalogId />
    </Form.Item>
  );
};
